import React from 'react';
import { Button, Table } from 'react-bootstrap';

const MakeAdminRow = ({ index, user }) => {
  const { _id, email, role } = user;
  const handleMakeAdmin = () => {
    fetch(`https://warehouse-management-server-30mo.onrender.com/user/admin/${email}`, {
      method: 'PUT'
    })
      .then(res => res.json())
      .then(data => {
        console.log('Make this user admin ', data);
        window.alert('Made this user Admin Successfully')
      })
  }
  return (
    <tr>
      <td>{index + 1}</td>
      <td>{user.email}</td>
      <td>
        {
          role === 'admin' ?
            <h6>Admin</h6>
            :
            <Button onClick={handleMakeAdmin} size="sm" style={{ backgroundColor: "#F2A70C", color: "black" }}>Make Admin</Button>
        }
      </td>
      <td>
        <Button size="sm" style={{ backgroundColor: "#F2A70C", color: "black" }}>Remove User</Button>
      </td>
    </tr>
  );
};

export default MakeAdminRow;